import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import { CountryProvider } from "@/context/CountryContext";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import FounderInsights from "@/pages/FounderInsights";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CountryProvider>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/founder-insights" element={<FounderInsights />} />
            </Routes>
          </SmoothScroll>
        </CountryProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
